import React, { useState } from "react";
import { PropTypes } from "prop-types";
import { Row, Col, message } from "antd";
import { useFormik } from "formik";
import { EditableInput } from "../../components/forms/editable-input";
import { Btn } from "../../components/forms/button";
import { authActions } from "../../store/actions";
import { useDispatch } from "react-redux";
import { Spinner } from "../../components";
export const EmployeeInfoDrawer = (props) => {
  let [load, setLoad] = useState(false);
  let dispatch = useDispatch();
  console.log(props.details);
  const onSubmitFunction = (values, { resetForm }) => {
    setLoad(true);

    let letterNumber = /^[0-9]+$/;
    let regexEmail = /^\w+([./-]?\w+)*@\w+([./-]?\w+)*(\.\w{2,3})+$/;

    if (JSON.stringify(values) === "{}") {
      message.error("you have not updated any field !");
      setLoad(false);
    } else if (values?.telephone?.length < 17) {
      message.error("Telephone Number Must Be Greater Than 17 Digits");
      setLoad(false);
    } else if (values?.telephone?.length > 17) {
      message.error("Telephone Number Must Be Smaller Than 17 Digits");
      setLoad(false);
    } else if (
      values?.telephone?.length === 17 &&
      !values?.telephone?.match(letterNumber)
    ) {
      message.error("Telephone Number Must Be Digits Only");
      setLoad(false);
    } else if (values?.email?.length > 5 && !values?.email?.match(regexEmail)) {
      message.error("Enter a valid email");
      setLoad(false);
    } else {
      dispatch(
        authActions.personalInfoUpdateDrawer(values, props.details.id, setLoad)
      );

      resetForm();
    }
  };

  const formik = useFormik({
    initialValues: {},

    onSubmit: onSubmitFunction,
  });
  return (
    <div className="pl-3 pr-3">
      <form onSubmit={formik.handleSubmit}>
        <h2 className="title">Detail</h2>
        <Row justify="space-between">
          <Col sm={24} md={11} xs={24} lg={11} className="mx-1 mt-5">
            <div className="user-information-modal-title flex justify-between align-center">
              <label className="pr-5 font-semibold">Fisrt Name</label>
            </div>
            {
              <EditableInput
                name={"first_name"}
                value={props.details.firstName}
                text={props.details.firstName}
                onChange={formik.handleChange}
                cursorPointer="cursor-pointer"
              />
            }
          </Col>
          <Col sm={24} md={11} xs={24} lg={11} className="mx-1 mt-5">
            <div className="user-information-modal-title flex justify-between align-center">
              <label className="pr-5 font-semibold">Last Name</label>
            </div>
            {
              <EditableInput
                name={"last_name"}
                value={props.details.lastName}
                text={props.details.lastName}
                onChange={formik.handleChange}
                cursorPointer="cursor-pointer"
              />
            }
          </Col>

          <Col sm={24} md={11} xs={24} lg={11} className="mx-1 mt-5">
            <div className="user-information-modal-title flex justify-between align-center">
              <label className="pr-5 font-semibold user-information-modal-title">
                ID
              </label>
            </div>
            <p className="user-information-modal-title">{props.details.id}</p>
          </Col>
          <Col sm={24} md={11} xs={24} lg={11} className="mx-1 mt-5">
            <div className="user-information-modal-title flex justify-between align-center">
              <label className="pr-5 font-semibold">Email</label>
            </div>
            {
              <EditableInput
                name="email"
                value={props.details.email}
                text={props.details.email}
                onChange={formik.handleChange}
                cursorPointer="cursor-pointer"
              />
            }
          </Col>
          <Col sm={24} md={11} xs={24} lg={11} className="mx-1 mt-5">
            <div className="user-information-modal-title flex justify-between align-center">
              <label className="pr-5 font-semibold">Telephone</label>
            </div>
            {
              <EditableInput
                name={"telephone"}
                value={props.details.telephone}
                text={props.details.telephone}
                onChange={formik.handleChange}
                cursorPointer="cursor-pointer"
              />
            }
          </Col>
          <Col sm={24} md={11} xs={24} lg={11} className="mx-1 mt-5">
            <div className="user-information-modal-title flex justify-between align-center">
              <label className="pr-5 font-semibold user-information-modal-title">
                Manager Id
              </label>
            </div>

            <p className="user-information-modal-title">{props.details.pid}</p>
          </Col>
          <Col sm={24} md={11} xs={24} lg={11} className="mx-1 mt-5">
            <div className="user-information-modal-title flex justify-between align-center">
              <label className="pr-5 font-semibold user-information-modal-title">
                Status
              </label>
            </div>
            <p className="user-information-modal-title">
              {props.details.status}
            </p>
          </Col>
        </Row>

        <Row>
          <Col xs={24} sm={10} md={8} lg={6} className="w-1/4 mt-10">
            <div>
              <Btn
                value={
                  load ? (
                    <span>
                      <Spinner className="btn-spinner mr-2" /> Loading...
                    </span>
                  ) : (
                    "Submit"
                  )
                }
                bgColor="#008ba4"
                color="white"
                border="1px solid #c3c3c7"
                btnClass="btnDarkHover"
                type="submit"
              ></Btn>
            </div>
          </Col>
        </Row>
      </form>
    </div>
  );
};

EmployeeInfoDrawer.propTypes = {
  details: PropTypes.any,
};
